import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import {Http, Headers, RequestOptions } from '@angular/http';
import { HTTP } from '@ionic-native/http';
import 'rxjs/add/observable/fromPromise';
import { TranslateService } from '@ngx-translate/core';
import { AlertController,LoadingController,ToastController, } from 'ionic-angular';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
@Injectable()
export class HkApiproviderProvider {

/*   Thanks for Purchase */
/*   Buy App From Envato Get Lifetime Updates*/
/*   Tech Support : Whatsapp +917696355852, Skype : blackhat.ajay */
  /*******************************
 * 
 *  Developer : Ajay randhawa
 *  Email : ajayrandhawartg@gmail.com
 *  
 *  Please don't share this script on nulled websites 
 *  Buy from Envato & appreciate Developer
 * 
 * ******************************/


 /*******  CHANGE URL HERE ***************/
  static location = {
    latitude:'',
    longitude:''
  }
  //url = 'http://cinematicketingsys.com';
  url = 'https://cinema.we-count.info';
  static token = '0e719720ccc7dbad2c994918d4419e3142812c00ad32a639d0c0758e85f11cd0';
 /****************************************/
//we-count
 baseUrl = this.url + '/app/';
// moh
// baseUrl = this.url + '/app_v2/';
 
  data: any;
  categoryimagebaseurl = this.url + '/admin/images/category/';
  awardimagebaseurl = this.url + '/admin/images/award/';
  userimagebaseurl = this.url + '/admin/images/user/';
  version = '1.2';
  /*********************************************** */
  alert_message:any = [];
  constructor(public http: Http, public httpnative:HTTP,private translate: TranslateService, public alertCtrl: AlertController, public toastCtrl : ToastController, public loadingCtrl : LoadingController) {
  }

  postData(credentials, type){
    return new Promise((resolve, reject) =>{
      let headers = new Headers();
      this.http.post(this.baseUrl+type, JSON.stringify(credentials), {headers: headers}).
      subscribe(res =>{
        resolve(res.json());
      }, (err) =>{
        reject(err);
      });
    });
  }
  
  getData(url){
    return new Promise((resolve, reject) =>{
      let headers = new Headers();
      this.http.get(url).
      subscribe(res =>{
        resolve(res.json());
      }, (err) =>{
        reject(err);
      });
    });
  }
  

  postGetSMSToken(){
    return new Promise((resolve, reject) =>{
      let username = 'mytelb2b';
      let password = '5c24b3ef-bd07-4c3c-b456-6787e8b5e80f';
      const encoded = btoa(username + ":" + password);
      let details = {
        grant_type: "client_credentials"
      }
      let url = 'https://mpg-ids.mytel.com.mm/auth/realms/eis/protocol/openid-connect/token';
      this.httpnative.post(url,  details, {'Authorization': `Basic ${encoded}`, 'Content-Type': 'application/x-www-form-urlencoded','Accept': 'application/json' })
      .then( res => resolve(JSON.parse(res.data)))

     });
  }


postSMSSend(credentials, token){
  return new Promise((resolve, reject) =>{
    let headers = new Headers();
    headers.append('Authorization',`Bearer ${token}`);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    let url = 'https://mytelapigw.mytel.com.mm/msg-service/v1.3/smsmt/sent';
    this.http.post(url, JSON.stringify(credentials), {headers: headers}).
    subscribe(res =>{
      resolve(res.json());
    }, (err) =>{
      reject(err);
    });
  });
}

  postAyaPayHeader(credentials){
    return new Promise((resolve, reject) =>{
      let username = 'w5sfIq2NHJwak5Lq9xVclhHQ2ssa';
      let password = 'inu80WfaiaYDn00TTdaZXmJzjJ4a';
      const encoded = btoa(username + ":" + password);
       let url = 'https://api.ayapay.com/token';
       // let url = 'https://opensandbox.ayainnovation.com/token';
       this.httpnative.post(url,  credentials, {'Authorization': `Basic ${encoded}`, 'Content-Type': 'application/x-www-form-urlencoded','Accept': 'application/json' })
       .then( res => resolve(JSON.parse(res.data)))
    //   .catch( err => reject(JSON.parse(err)));
      });
  }


  postAyaPayLogin(credentials, token){
    return new Promise((resolve, reject) =>{
        let url = 'https://api.ayapay.com/merchant/1.0.0/thirdparty/merchant/login';
       //let url = 'https://opensandbox.ayainnovation.com/merchant/1.0.0/thirdparty/merchant/login';
       this.httpnative.post(url, credentials, {'Token': `Bearer ${token}`,'Content-Type': 'application/x-www-form-urlencoded','Accept': 'application/json' })
       .then( res => resolve(JSON.parse(res.data)))
      });
  }

  postAyaPayRequestPayment(credentials, token,authorization){
    return new Promise((resolve, reject) =>{
       let url = 'https://api.ayapay.com/merchant/1.0.0/thirdparty/merchant/requestPushPayment';
      // let url = 'https://opensandbox.ayainnovation.com/merchant/1.0.0/thirdparty/merchant/requestPushPayment';
       this.httpnative.post(url, credentials, {'Token': `Bearer ${token}`,'Authorization': `Bearer ${authorization}`,'Content-Type': 'application/x-www-form-urlencoded','Accept': 'application/json' })
       .then( res => {
        resolve(JSON.parse(res.data));
       });
    });
  }

  postKBZPrecreate(credentials){
    return new Promise((resolve, reject) =>{
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      let url = 'http://api.kbzpay.com/payment/gateway/uat/precreate/';
    // let url = 'https://api.kbzpay.com/payment/gateway/precreate';
      this.http.post(url, JSON.stringify(credentials), {headers: headers}).
      subscribe(res =>{
        resolve(res.json());
      }, (err) =>{
        reject(err);
      });
    });
  }

  postKBZQuearyOrder(credentials){
    return new Promise((resolve, reject) =>{
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      let url = 'http://api.kbzpay.com/payment/gateway/uat/queryorder';
    // let url = 'https://api.kbzpay.com/payment/gateway/queryorder';
      this.http.post(url, JSON.stringify(credentials), {headers: headers}).
      subscribe(res =>{
        resolve(res.json());
      }, (err) =>{
        reject(err);
      });
    });
  }
  
 /*
  postKBZPrecreate(credentials){
    return new Promise((resolve, reject) =>{
      let url = 'http://api.kbzpay.com/payment/gateway/uat/precreate';
    // let url = 'https://api.kbzpay.com/payment/gateway/precreate';
      this.httpnative.post(url, JSON.stringify(credentials), { 'Content-Type': 'application/json' })
      .then( res => resolve(JSON.parse(res.data)))
      });
  }
  */

  postOnePayRequestPayment(credentials){
    return new Promise((resolve, reject) =>{
      let url = 'https://onepayuat.agdbank.com/API/Ver01/Wallet/Wallet_VerifyPhoneNumber';
      this.httpnative.post(url, credentials, {'Content-Type': 'application/x-www-form-urlencoded' })
      .then( res => {
        resolve(JSON.parse(res.data));
      });
    });
  }
  postOnepayMadePayment(credentials){
    return new Promise((resolve, reject) =>{
      let url = 'https://onepayuat.agdbank.com/API/Ver02/Wallet/Wallet_DirectAPIV2';
      this.httpnative.post(url, credentials, {'Content-Type': 'application/x-www-form-urlencoded' })
      .then( res => {
        resolve(JSON.parse(res.data));
      });
    });
  }
  getAwardimage(){
    return this.awardimagebaseurl;
  }
  getCategoryimage(){
    return this.categoryimagebaseurl;
  }
  getUserImage(){
    return this.userimagebaseurl;
  }
  getBaseUrl(){
    return this.url;
  }

  static gettoken(){
    return HkApiproviderProvider.token;
  }
  
  apptranslate(tran_text:string){
    let tran_finish='';
    this.translate.get(tran_text).subscribe(t => {
			tran_finish=t;
    });
    return tran_finish;
  }

  loadingMessage(message:string){
   let loader = this.loadingCtrl.create({
       content: this.apptranslate(message),
       duration: 20000
   });
   return loader;
  }

  toastMessage(message:string){
    this.alert_message.cartUpdated = this.apptranslate(message);
    this.toastCtrl.create({
      message: this.alert_message.cartUpdated,
      duration: 1000
    }).present();
  }

  showalertinfo(title,message){
		this.translate.get(title).subscribe(t => {
			this.alert_message.title = t;
		});
		this.translate.get(message).subscribe(t => {
			this.alert_message.message = t;
		});
		let alert = this.alertCtrl.create({
			title:this.alert_message.title,
			subTitle:this.alert_message.message,
			buttons:["OK"]
		});
		alert.present();
  }
  
  promptAlert(title:string,message:string){
    let alert = this.alertCtrl.create({
        title: this.apptranslate(title),
        message: this.apptranslate(message),
        buttons: [
            {
                text: 'Yes',
                handler: () => {
                    alert.dismiss(true);
                    return false;
                }
            }, {
                text: 'No',
                handler: () => {
                    alert.dismiss(false);
                    return false;
                }
            }
        ]
    });
    return alert;
}
exportToExcel(data, filename) {
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, filename);
  XLSX.writeFile(wb, filename + '.xlsx');
}

enToMyanmarNumber(data:any){
  let returnText ="";
  for(let i = 0; i < data.length; i++){
    returnText += this.apptranslate(data.substring(i,i+1));
  }
  return returnText;
}

enToMyanmarNumberLastInput(data:any){
  let translateText = "";
  if(data!=''){
    if(''+Number(data.substring(data.length-1,data.length)) != 'NaN'){
      translateText = this.apptranslate(data.substring(data.length-1,data.length));
    } else {
      translateText = '';
    }
    return data.substring(0,data.length-1)+translateText;
  }
}
}



// WEBPACK FOOTER //
// ./src/providers/hk-apiprovider/hk-apiprovider.ts